<!--
 Created by Yaroslav S. on 10/07/2024
 Copyright © 2020 Curriculum Ltd. All rights reserved.
-->

<div class="deepseek-section">
  <div class="deepseek-section-title">DeepSeek AI</div>

  <div class="form-fields">
    <div class="form-fields-label">Secret Key</div>
    <curr-input
      [formGroup]="form"
      controlName="deepSeekApiKey"
      class="full-width form-field"
      [errorMessage]="form.controls['deepSeekApiKey'].hasError('required') ? 'Secret Key is required' : ''"
    ></curr-input>
  </div>

  <curr-credits-error *ngIf="showError"></curr-credits-error>

  <div class="save-actions">
    <curr-button
      variant="contained"
      [isDisabled]="form.invalid || !deepSeekApiKey.dirty"
      (btnClick)="saveApiKey()"
      size="big"
      >SAVE</curr-button
    >
  </div>
</div>
